import { useCallback } from 'react';
import useSite from '~/client/hooks/useSite';
import { useToggleMbtcMutation } from './ToggleMbtcMutation.generated';
import useToggleBTCDisplayType from './useToggleBTCDisplayType';
import useTags from '../../feature/useTags';

const useToggleMbtc = () => {
  const { isBridgeSite } = useSite();
  const tags = useTags();
  const [toggleMbtcMutation] = useToggleMbtcMutation();
  const { toggleBTCDisplayType } = useToggleBTCDisplayType();

  const toggleMbtc = useCallback(async () => {
    if (isBridgeSite) {
      await toggleBTCDisplayType();
    } else {
      await toggleMbtcMutation({
        optimisticResponse: {
          __typename: 'Mutation',
          featuresToggleMbtc: {
            __typename: 'FeaturesToggleMbtcPayload',
            errors: [],
            isMbtcEnabled: !tags.mBTC,
            features: {
              ...tags,
              __typename: 'Features',
              id: tags.id ?? '',
              mBTC: !tags.mBTC,
              uBTC: !tags.uBTC,
            },
          },
        },
      });
    }
  }, [tags, isBridgeSite, toggleBTCDisplayType, toggleMbtcMutation]);

  return { toggleMbtc, isMBTCEnabled: tags.mBTC, isUBTCEnabled: tags.uBTC };
};

export default useToggleMbtc;
